export default __webpack_public_path__ + "static/media/Textile_apparel_exporters.136c45d5.png";